var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2759 12.3079L6.6537 10.3592C6.61167 10.3363 6.562 10.3363 6.51997 10.3592L2.86336 12.2391C2.75638 12.2926 2.63411 12.2009 2.65321 12.0862L3.38683 8.03991C3.39447 7.99405 3.37919 7.94438 3.3448 7.90999L0.425627 5.00993C0.341568 4.92587 0.387418 4.78067 0.509687 4.76539L4.58659 4.21136C4.63244 4.20372 4.67447 4.17697 4.6974 4.13494L6.55054 0.463051C6.60403 0.356066 6.75687 0.356066 6.81036 0.463051L8.59472 4.16933C8.61382 4.21136 8.65586 4.24193 8.70171 4.24957L12.7671 4.88002C12.8856 4.89912 12.9314 5.04432 12.8436 5.12838L9.8709 7.97113C9.83651 8.00552 9.82123 8.05137 9.82887 8.09722L10.4861 12.1588C10.5052 12.2773 10.3791 12.3652 10.2759 12.3079Z",
    fill: "#183243",
    stroke: "#183243",
    strokeWidth: 0.764181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredIcon);
export default __webpack_public_path__ + "static/media/starred_icon.041bdeee7016cdb42e0bfb3b828ff295.svg";
export { ForwardRef as ReactComponent };